import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { PrincipalService } from './principal.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(private principal: PrincipalService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const allowedRoles = route.data.allowedRoles as Array<string>;
    if (this.principal.hasRoles(allowedRoles)) {
      return true;
    } else {
      this.router.navigate(['/not-found']);
      return false;
    }
  }
}
